<template>
  <div>
    <b-modal
      class="modal-attendance-employee-perMonth"
      id="modal-attendance-employee-perMonth"
      hide-footer
      centered
      size="s"
      title="View Attendance Employee Per Month"
    >
      <div class="profile-employee text-muted ml-2 mr-2">
        <h5>{{ employee.name }}</h5>
        <div class="d-flex justify-content-between mt-2 ml-2 mr-2">
          <div>
            Employee ID
          </div>
          <div>
            {{ employee.employeeNo }}
          </div>
        </div>
        <div class="d-flex justify-content-between mt-2 ml-2 mr-2">
          <div>
            Position
          </div>
          <div>
            {{ employee.position }}
          </div>
        </div>
        <div class="mt-2 ml-2 mr-2">
          Periode: <b>{{ startDate }}</b> - <b>{{ endDate }}</b>
        </div>
        <div class="mt-2 ml-3 mr-3">
          <p>{{ employee.status }}</p>
          <b-progress :max="employee.target">
            <b-progress-bar :value="employee.realization" :label="`${((employee.realization / employee.target) * 100).toFixed(2)} %`"></b-progress-bar>
          </b-progress>
        </div>
      </div>
      <div class="attendance-report-per-month mt-3 ml-4 mr-4 d-flex justify-content-between">
        <div class="attendance mr-4">
          <b-table
            v-show="attendance1.length > 0"
            :fields="fields"
            :items="attendance1"
            thead-class="d-none"
          >
          </b-table>
        </div>
        <div class="attendance ml-4">
          <b-table
            v-show="attendance2.length > 0"
            :fields="fields"
            :items="attendance2"
            thead-class="d-none"
          >
          </b-table>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    typeAttendance: {
      type: Array,
      default: () => []
    },
    employee: {
      type: Object,
      default: () => {}
    },
    attendanceMontly: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      attendance1: [],
      attendance2: [],
      totalAttendance: [],
      attendanceEmployeeMontly: [],
      fields: [
        { key: 'attendanceType', label: 'Attendance' },
        { key: 'total', label: 'Total' }
      ],
      currentDate: new Date(),
      startDate: '',
      endDate: ''
    }
  },
  methods: {
    setTotalAttendance() {
      this.attendance1.forEach(attendance => {
        attendance.total = 0
      })
      this.attendance2.forEach(attendance => {
        attendance.total = 0
      })
      this.attendanceEmployeeMontly.forEach(item => {
        this.typeAttendance.forEach(type => {
          if (item.attendanceTypeId === type.id) {
            this.attendance1.forEach(attendance => {
              if (attendance.id === type.id) {
                attendance.total = parseInt(attendance.total + 1)
              }
            })
            this.attendance2.forEach(attendance => {
              if (attendance.id === type.id) {
                attendance.total = parseInt(attendance.total + 1)
              }
            })
          }
        })
      })
    },
    setStartDateEndDate() {
      const year = this.currentDate.getFullYear()
      const month = this.currentDate.getMonth()
      const startDate = new Date(year, month, 1)
      const endDate = new Date(year, month + 1, 0)
      this.startDate = this.formatedDate(startDate)
      this.endDate = this.formatedDate(endDate)
    },
    formatedDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
  },
  watch: {
    typeAttendance: {
      handler() {
        this.attendance1 = []
        this.attendance2 = []
        this.typeAttendance.forEach((type, index) => {
          if (index <= 5) {
            this.attendance1.push({ attendanceType: type.name, id: type.id, total: 0 })
          } else {
            this.attendance2.push({ attendanceType: type.name, id: type.id, total: 0 })
          }
        })
      },
      immediate: true
    },
    attendanceMontly: {
      handler() {
        this.attendanceEmployeeMontly = []
        this.attendanceEmployeeMontly = this.attendanceMontly
        this.setTotalAttendance()
      },
      immediate: true
    }
  },
  created() {
    this.setStartDateEndDate()
  }
}
</script>

<style lang="scss" scoped>
.attendance{
  width: 50vh;
}
</style>
